import { render, staticRenderFns } from "./BuyDropConfirmation.vue?vue&type=template&id=3d8291d8&scoped=true&"
import script from "./BuyDropConfirmation.vue?vue&type=script&lang=js&"
export * from "./BuyDropConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8291d8",
  null
  
)

export default component.exports